import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-metric',
  templateUrl: './metric.component.html',
  styleUrls: ['./metric.component.scss'],
})
export class MetricComponent {
  @Input() title: string = '';
  @Input() value: string | number | null = '-';
  @Input() subtitle: string | null = null;
  @Input() icon: string = '';
  @Input() iconBg: string = '';
  @Input() loading: boolean = false;
  @Input() mode: 'card' | 'line' = 'card';
  @Input() severity: 'success' | 'info' | 'danger' | 'warning' = 'info';
}
